import { render, staticRenderFns } from "./TeamEventDashboard.vue?vue&type=template&id=619535de"
import script from "./TeamEventDashboard.vue?vue&type=script&lang=js"
export * from "./TeamEventDashboard.vue?vue&type=script&lang=js"
import style0 from "./TeamEventDashboard.vue?vue&type=style&index=0&id=619535de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports